// extracted by mini-css-extract-plugin
var _1 = "ra-quiz-container";
var _2 = "ra-quiz-container-slider";
var _3 = "ra-quiz-container-slider-item";
var _4 = "ra-quiz-container-slider-single-slide";
var _5 = "ra-quiz-container-slider-vertical";
export { _1 as "quizContainerCls", _2 as "quizContainerSliderCls", _3 as "quizContainerSliderItemCls", _4 as "quizContainerSliderSingleSlideCls", _5 as "quizContainerSliderVerticalCls" }
